const getDateRangeTextFromKey = (key) => {
  switch (key) {
    case 3:
      return "3 days ago"
    case 7:
      return "7 days ago"
    case 30:
      return "Previous Month + Current Month"
    case 90:
      return "Previous 3 Months + Current Month"
    case 180:
      return "Previous 6 Months + Current Month"
    case 365:
      return "Previous 12 Months + Current Month"
    default:
      return "Custom date range"
  }
}

export default getDateRangeTextFromKey
